
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import Transcription from '@/store/modules/transcription';
import store from '@/store/store';
import { Watch } from 'vue-property-decorator';
import { ITranscriptionHistory } from '../../types';
import TrscHistoryEntry from './TrscHistoryEntry.vue';
import DiffDialog from './DiffDialog.vue';
import { db } from '../../plugins/firebase';

const trscModule = getModule(Transcription, store);

@Component({ components: { TrscHistoryEntry, DiffDialog } })
export default class TrscHistory extends Vue {
  history: ITranscriptionHistory[] = [];
  openDiffDialog = false;
  current = {};
  previous = {};

  @Watch('$route.params.page')
  bindHistory() {
    const {entryId, page} = this.$route.params
    const index = parseInt(page) -1
    const trscId = `${entryId}_${index}`
    const query = db
      .collection('transcriptions')
      .doc(trscId)
      .collection('history')
      .orderBy('timestamp', 'desc');
    this.$bind('history', query);
  }

  mounted() {
    this.bindHistory()
  }

  showDiff(current: ITranscriptionHistory, previous: ITranscriptionHistory) {
    //console.log(current, previous);
    this.current = current;
    this.previous = previous;
    this.openDiffDialog = true;
  }
}
